import { i18n } from "@lingui/core";
import { t } from "@lingui/core/macro";
import { formatNumber } from "@regrello/core-utils";

/**
 * A select-menu option definition that would control whether to disable thousands separators when
 * displaying values from a float-valued field.
 */
export type DisallowGroupingsFloatOption = {
  value: boolean;
  label: string;
  preview: string;
};

/**
 * Returns an array of select-menu option definitions for the "disallow_groupings_float" menu in
 * Create/Edit field dialogs.
 *
 * ___Note:___ This must be invoked at runtime because i18n.locale must first have a chance to be
 * detected and initialized on app load.
 */
export function getDisallowGroupingsFloatMenuOptions(): DisallowGroupingsFloatOption[] {
  return [
    {
      value: false,
      label: t`Enabled`,
      preview: formatNumber(1234567, i18n.locale, { decimalPlaces: 0, disallowGroupings: false }),
    },
    {
      value: true,
      label: t`Disabled`,
      preview: formatNumber(1234567, i18n.locale, { decimalPlaces: 0, disallowGroupings: true }),
    },
  ];
}

/**
 * Returns the option from the list of disallow_groupings_float options that matches the given value.
 *
 * @param value - The value to search for.
 * @returns The option from the list of disallow_groupings_float options that matches the given
 * value, or undefined if no match is found.
 */
export function getDisallowGroupingsFloatOption(value: boolean): DisallowGroupingsFloatOption | undefined {
  return getDisallowGroupingsFloatMenuOptions().find((option) => option.value === value);
}
